{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "http://softball.app/schemas/top-level-full",
  "title": "Top Level Full",
  "description": "Complete schema for all the data associated with an account",
  "type": "object",
  "required": ["metadata", "account", "players", "optimizations", "teams"],
  "unevaluatedProperties": false,
  "properties": {
    "metadata": {
      "description": "Information about the json document itself",
      "type": "object",
      "required": ["version", "scope"],
      "unevaluatedProperties": false,
      "properties": {
        "version": {
          "type": "integer",
          "description": "The version schema version of the json document"
        },
        "scope": {
          "type": "string",
          "enum": ["full"],
          "description": "All account data is present"
        }
      }
    },
    "account": {
      "type": "object",
      "unevaluatedProperties": false,
      "allOf": [
        { "$ref": "http://softball.app/schemas/account" },
        { "$ref": "http://softball.app/schemas/account-private" },
        {
          "$ref": "http://softball.app/schemas/account-read-only",
          "required": ["accountId", "email", "emailConfirmed", "balance"]
        }
      ]
    },
    "players": {
      "description": "List of all players associated with this account",
      "type": "array",
      "items": {
        "type": "object",
        "unevaluatedProperties": false,
        "$ref": "http://softball.app/schemas/player"
      }
    },
    "teams": {
      "description": "List of all teams associated with this account",
      "type": "array",
      "items": {
        "type": "object",
        "unevaluatedProperties": false,
        "allOf": [
          { "$ref": "http://softball.app/schemas/team-read-only" },
          { "$ref": "http://softball.app/schemas/team" }
        ]
      }
    },
    "optimizations": {
      "type": "array",
      "description": "List of all optimizations associated with this account",
      "items": {
        "type": "object",
        "unevaluatedProperties": false,
        "allOf": [
          { "$ref": "http://softball.app/schemas/optimization-read-only" },
          { "$ref": "http://softball.app/schemas/optimization" }
        ]
      }
    }
  }
}
